import React from 'react';
import { Field } from '@truvity/widget__forms';
import { ReadonlyField } from '@truvity/widget__forms-mui-theme';
import { Typography } from '@mui/material';

export const ReadonlyTextareaField = (props: Field<string | undefined>) => (
    <ReadonlyField
        {...props}
        isEmpty={(value) => value === ''}
        formatValue={(value) => (
            <Typography variant="inherit" sx={{ whiteSpace: 'pre-line' }}>
                {value}
            </Typography>
        )}
    />
);
